import * as React from 'react'
import { useThemeUI } from 'theme-ui'
import { TruCaret } from '@uswitch/spark-icons/tru'

export const DropDown = ({
  title,
  isInitiallyOpen = false,
  children,
  className,
  isCard = false,
  variant = 'base',
}) => {
  const {
    theme: {
      compounds: { accordion: accordionTheme = {} },
      colors = {},
    },
  } = useThemeUI()

  const [isOpen, setIsOpen] = React.useState(isInitiallyOpen)

  const getIconColor = isOpen => {
    if (variant === 'eligibility-criteria-redesign') {
      return colors['button-secondary']
    } else {
      return isOpen
        ? colors[accordionTheme?.base?.isActive?.caret?.color]
        : colors[accordionTheme?.base?.caret?.color]
    }
  }

  const getVariant = (element, isOpen) => {
    const baseVariant = variant && variant !== 'base' ? `.variants.${variant}` : '.base'
    const elementVariant = element ? `.${element}` : ''
    const activeVariant = isOpen ? '.isActive' : ''
    return `compounds.accordion${baseVariant}${activeVariant}${elementVariant}`
  }

  const getCardStyles = () =>
    isCard
      ? {
          position: 'absolute',
          bottom: '0',
          mb: '0',
          width: '100%',
          minHeight: isOpen ? '80%' : 'auto',
          boxShadow: isOpen
            ? '0px -1px 16px rgba(0, 0, 0, 0.15), 0px -159px 36px 4px rgba(255, 255, 255, 0.7)'
            : 'none',
        }
      : {}

  return (
    <div
      sx={{
        variant: getVariant('wrapper', isOpen),
        ...getCardStyles(),
      }}
      className={className}
    >
      <button
        sx={{
          color: 'textColor',
          cursor: 'pointer',
          variant: getVariant('btn', isOpen),
        }}
        onClick={event => {
          event.preventDefault()
          event.stopPropagation()
          setIsOpen(!isOpen)
        }}
      >
        <div
          sx={{
            flex: '1',
            textAlign: 'left',
            variant: getVariant('title'),
          }}
        >
          {title}
        </div>
        {isOpen === 'up' ? (
          <TruCaret color={getIconColor(isOpen)} size={16} />
        ) : (
          <TruCaret color={getIconColor(isOpen)} size={16} sx={{ transform: 'rotate(0.5turn)' }} />
        )}
      </button>

      <div
        sx={{
          color: 'textColor',
          overflow: 'hidden',
          height: isOpen ? 'auto' : '0',
          marginBottom: isOpen ? accordionTheme?.base?.content?.marginBottom : '0',
          '> *:first-of-type': {
            marginTop: 0,
          },
          '> *:last-child': {
            marginBottom: 0,
          },
          '> p:last-child': {
            marginBottom: 'xs',
          },
          variant: getVariant('content'),
        }}
      >
        {children}
      </div>
    </div>
  )
}
export default DropDown
